import React, { ReactElement } from 'react'
import PropTypes from 'prop-types'
import connectConditionalResults from '../../Connectors/statsConnector'
import Pluralize from 'react-pluralize'
import Helper from 'utils/Helper.class'

type PropTypes = {
  translate: (
    title: string,
    nbHits: number,
    processingTimeMS: number,
  ) => ReactElement
  nbHits: number
  processingTimeMS: number
  className: string
  title: string
  resultName: string
  allSearchResults: any
  indexes?: string[]
  contextValue: { store: { getState: () => any } }
}

/**
 *
 * @param props
 * @constructor
 */
const SearchStats = (props: PropTypes & any) => {
  const {
    nbHits,
    title,
    resultName,
    allSearchResults,
    indexes,
    contextValue,
  }: PropTypes = props
  const state = contextValue.store.getState()

  const totalAmount = indexes
    ? indexes.reduce(
        (totalAmount: number, index: string) =>
          allSearchResults
            ? totalAmount + (parseInt(allSearchResults[index]?.nbHits) || 0)
            : totalAmount,
        0,
      )
    : nbHits

  return !state.searching ? (
    <h2>
      {Helper.formatThousandsWithRounding(totalAmount, 0)}{' '}
      <Pluralize singular={resultName} count={totalAmount} showCount={false} />{' '}
      {title}
    </h2>
  ) : null
}

export default connectConditionalResults(SearchStats)
